
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Icons / warning","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 21.503 19.58"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Combined Shape","d":"M3.093 19.58a3.087 3.087 0 01-2.68-4.62L8.071 1.556a3.087 3.087 0 015.361 0l7.659 13.4a3.088 3.088 0 01-2.681 4.62zM9.374 2.3L1.715 15.7a1.587 1.587 0 001.378 2.374h15.318a1.587 1.587 0 001.377-2.374L12.129 2.3a1.585 1.585 0 00-2.755 0zm.378 11.87a1 1 0 01.89-1l.109-.006.117.006a1 1 0 11-1.116 1zm.257-3.159l-.007-.1V7.169a.75.75 0 011.493-.1l.007.1v3.74a.75.75 0 01-1.493.1z","fill":"#e22547"}})])
          )
        }
      }
    